// removed by extract-text-webpack-plugin
module.exports = {"container":"style__container-2nu7b","footer":"style__footer-1DDNR","footerB":"style__footerB-1hhT1"};


//////////////////
// WEBPACK FOOTER
// ./src/views/MainLayout/FooterBar/style.less
// module id = 363
// module chunks = 17